var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "el:phone-alt",
    clipPath: "url(#clip0_666_5207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1925 0.874512C4.66965 0.874512 0.192505 5.35166 0.192505 10.8745C0.192505 16.3974 4.66965 20.8745 10.1925 20.8745C15.7154 20.8745 20.1925 16.3974 20.1925 10.8745C20.1925 5.35166 15.7154 0.874512 10.1925 0.874512ZM6.59876 4.84668C6.80479 4.83453 6.99102 4.95768 7.13221 5.17626L8.49939 7.76903C8.64334 8.07626 8.56154 8.40523 8.34681 8.62475L7.72059 9.25096C7.68194 9.30393 7.65651 9.36358 7.65589 9.42918C7.89604 10.3588 8.62451 11.2162 9.26724 11.8059C9.90994 12.3956 10.6007 13.1939 11.4974 13.383C11.6083 13.414 11.7441 13.425 11.8234 13.3513L12.5509 12.6104C12.802 12.42 13.1653 12.3278 13.4335 12.4834H13.4457L15.9127 13.9397C16.2748 14.1667 16.3123 14.6054 16.0531 14.8723L14.3539 16.5581C14.103 16.8154 13.7696 16.902 13.4457 16.9023C12.0132 16.8594 10.6597 16.1564 9.54801 15.4338C7.72317 14.1063 6.04929 12.4597 4.99842 10.4705C4.59539 9.6363 4.12194 8.57196 4.16712 7.6409C4.17116 7.29063 4.26592 6.94748 4.51259 6.72171L6.2118 5.0225C6.34417 4.90986 6.47512 4.85398 6.59876 4.84668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_5207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.192505 0.874512)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1ad158fc4172d24448a7f776aec4ce1e.svg";
export { ForwardRef as ReactComponent };